import React, {createContext, useContext, useEffect, useState} from "react";
import axios from "axios";
import {deleteFavoriteShopFromLS, loadFavoriteShopFromLS, saveFavoriteShopToLS} from "./uc/storage.ts";
import {Salepoint, City} from "./uc/domain.ts";

interface SalepointContextType {
    favoriteShop: Salepoint | undefined;
    setFavoriteShop: (shopRef: string | undefined) => void;
    allShops: Salepoint[];
    shopInCity: Salepoint[];
    cities: City[];
    city: City | undefined;
    setCity: (city: City | undefined) => void;
}
export const SalepointContext = createContext<SalepointContextType|null>(null);
export function SalepointProvider ({ children }: { children: React.ReactNode }) {
    const [favoriteShop, setFavoriteShopState] = useState<Salepoint|undefined>(loadFavoriteShopFromLS())
    const [favoriteCity, setFavoriteCity] = useState<City|undefined>(loadFavoriteShopFromLS()?.city)
    const [shopsByCity, setShopsByCity] = useState<Salepoint[]>([])
    const [allShops, setShops] =useState<Salepoint[]>([])
    const [cities, setCities] = useState<City[]>([])

    const setShopsInCurrentCity = () => {
        if (favoriteCity === undefined || (favoriteShop !== undefined && favoriteCity.id !== favoriteShop?.cityID)) {
            const city = cities.filter(el => favoriteShop?.cityID)
            if (city.length ===1 ) {
                setFavoriteCity(city[0])
            }
        }
        const shopsInCity= allShops.filter(el => {
            return el.cityID === favoriteCity?.id})
        setShopsByCity(shopsInCity)
    }
    const collectUniqCitiesFromShop = () => {
        const handled = new Set()
        const result = []
        allShops.forEach(el => {
            if (!handled.has(el.cityID)) {
                handled.add(el.cityID)
                result.push({id: el.cityID, name: el.city.name})
            }
        })
        setCities(result)
    }
    useEffect(collectUniqCitiesFromShop, [allShops])
    useEffect(setShopsInCurrentCity, [allShops, favoriteCity, favoriteShop]);
    useEffect(() => {
        const shopFromStorage = loadFavoriteShopFromLS();
        if (shopFromStorage) {
            setFavoriteShopState(shopFromStorage);
            setFavoriteCity(shopFromStorage.city);
        }
        const loadShops = async () => {
            const result = await axios.get('/shops')
            setShops(result.data)
        }
        loadShops()
    }, [])
    const setUserShop = (salePointRef:string|undefined) => {
        if (salePointRef === undefined) {
            deleteFavoriteShopFromLS()
            setFavoriteShopState(undefined)
            return
        }
        const salePoints = allShops.filter(el => el.sanremoRef === salePointRef)
        if (salePoints.length === 1) {
            saveFavoriteShopToLS(salePoints[0])
            setFavoriteShopState(salePoints[0])
        }
    }
    return <SalepointContext.Provider value={{
        favoriteShop: favoriteShop,
        setFavoriteShop: setUserShop,
        allShops: allShops,
        shopInCity: shopsByCity,
        setCity:setFavoriteCity,
        city: favoriteCity,
        cities: cities }}>
        {children}
    </SalepointContext.Provider>
}
